import {
  AnimateLayoutChanges,
  defaultAnimateLayoutChanges,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { UniqueIdentifier } from "@dnd-kit/core";
import { PropsWithChildren } from "react";
import { ListGroup } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGrip } from "@fortawesome/free-solid-svg-icons";
import { EntryContent } from "../../common/components/multiselectablelist/EntryContent";
import { CyPlaylistItem } from "../item/CyPlaylistItem";
import { selectedClasses } from "../../common/components/list/ClassModifiers";

interface Props {
  id: UniqueIdentifier;
  isSelected: boolean;
  to?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const animateLayoutChanges: AnimateLayoutChanges = (args) =>
  defaultAnimateLayoutChanges({ ...args, wasDragging: true });

export function SortablePlaylistItemSong({
  children,
  id,
  isSelected,
  to,
  onClick,
  disabled,
}: PropsWithChildren<Props>) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: id,
      animateLayoutChanges: animateLayoutChanges,
      disabled: disabled,
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={{ ...style, display: "flex" }}
      data-sortable-id={id}
    >
      <ListGroup
        horizontal
        className="border-top rounded-0 bg-white"
        style={{ flex: "1 1 auto", minWidth: 0 }}
      >
        <div
          {...attributes}
          {...listeners}
          style={{ touchAction: "none" }}
          className={`d-flex with-left-column col-auto align-items-center justify-content-center ${selectedClasses(isSelected)}`}
          data-cy={CyPlaylistItem.DragHandle}
        >
          <FontAwesomeIcon className="text-secondary" icon={faGrip} />
        </div>
        <EntryContent isSelected={isSelected} to={to} onClick={onClick}>
          {children}
        </EntryContent>
      </ListGroup>
    </div>
  );
}
